import Container from "Components/Container/Container";
import logo from "assets/white-logo.png";
import Terms from "./Terms";
import Social from "./Social";
import FooterNav from "./FooterNav";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-black py-secondary mt-secondary lg:mt-primary">
      <Container>
        <div className="flex flex-col items-center gap-4 sm:gap-5 md:gap-6 lg:gap-10">
          <img
            className="w-[14rem] lg:w-[16rem]"
            src={logo}
            alt={t("common.logo")}
          />
          <div className="w-full sm:w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%]">
            <FooterNav t={t} />
            <Terms t={t} />
            <Social t={t} />
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
